/**
 * Coalesces overlapping registration-status refetches after WebSocket `registration-status-update`.
 * One in-flight GET satisfies every concurrent caller (same pattern as {@link fetchPairingRegistrationWithDedupe}).
 */
export function createRegistrationStatusPushRefetchCoalescer(
  runOnce: () => Promise<void>
): () => Promise<void> {
  let inFlight: Promise<void> | null = null

  return async (): Promise<void> => {
    if (inFlight !== null) {
      return inFlight
    }
    inFlight = (async () => {
      try {
        await runOnce()
      }
      finally {
        inFlight = null
      }
    })()
    return inFlight
  }
}
